/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Confirm_Email_TitleInputs */

const de_login_confirm_email_title = /** @type {(inputs: Login_Confirm_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse bestätigen`)
};

/** @type {(inputs: Login_Confirm_Email_TitleInputs) => LocalizedString} */
const en_login_confirm_email_title = de_login_confirm_email_title;

/**

* @param {Login_Confirm_Email_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const login_confirm_email_title = /** @type {((inputs?: Login_Confirm_Email_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Confirm_Email_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_confirm_email_title(inputs)
	return en_login_confirm_email_title(inputs)
});